import { SORT_OPTIONS, YEARS } from "@/mocks/categories";

interface FilterPanelProps {
  title: string;
  genreOptions: string[];
  genre: string;
  onGenre: (v: string) => void;
  regionOptions: string[];
  region: string;
  onRegion: (v: string) => void;
  year: string;
  onYear: (v: string) => void;
  sort: string;
  onSort: (v: string) => void;
  onReset: () => void;
}

function Chip({
  active,
  label,
  onClick,
}: {
  active: boolean;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`rounded-md px-2.5 py-1.5 text-xs font-medium transition-colors ${
        active
          ? "bg-primary-600 text-background-50"
          : "bg-background-100 text-foreground-600 hover:bg-background-200"
      }`}
    >
      {label}
    </button>
  );
}

export default function FilterPanel({
  title,
  genreOptions,
  genre,
  onGenre,
  regionOptions,
  region,
  onRegion,
  year,
  onYear,
  sort,
  onSort,
  onReset,
}: FilterPanelProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-5 flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-filter-3-line text-accent-500"></i>
          筛选条件
        </h2>
        <button
          type="button"
          onClick={onReset}
          className="flex items-center gap-1 text-xs text-foreground-500 transition-colors hover:text-accent-600"
        >
          <i className="ri-refresh-line"></i>
          重置
        </button>
      </div>

      <div className="space-y-6">
        <div>
          <h3 className="mb-3 text-xs font-semibold tracking-wide text-foreground-500">题材类型</h3>
          <div className="flex flex-wrap gap-1.5">
            {genreOptions.map((g) => (
              <Chip key={g} active={genre === g} label={g} onClick={() => onGenre(g)} />
            ))}
          </div>
        </div>

        <div>
          <h3 className="mb-3 text-xs font-semibold tracking-wide text-foreground-500">地区</h3>
          <div className="flex flex-wrap gap-1.5">
            {regionOptions.map((r) => (
              <Chip key={r} active={region === r} label={r} onClick={() => onRegion(r)} />
            ))}
          </div>
        </div>

        <div>
          <h3 className="mb-3 text-xs font-semibold tracking-wide text-foreground-500">上映年份</h3>
          <div className="flex flex-wrap gap-1.5">
            {YEARS.map((y) => (
              <Chip key={y.value} active={year === y.value} label={y.label} onClick={() => onYear(y.value)} />
            ))}
          </div>
        </div>

        <div>
          <h3 className="mb-3 text-xs font-semibold tracking-wide text-foreground-500">排序方式</h3>
          <div className="flex flex-wrap gap-1.5">
            {SORT_OPTIONS.map((s) => (
              <Chip key={s.value} active={sort === s.value} label={s.label} onClick={() => onSort(s.value)} />
            ))}
          </div>
        </div>
      </div>

      <p className="mt-6 border-t border-background-200 pt-4 text-xs text-foreground-400">
        当前分类：{title}
      </p>
    </div>
  );
}